import React from 'react';
import { arrayOf, string } from 'prop-types';

import OrderDetails from '~screens/Commerce/components/OrderDetails';
import { arrayHasLength } from '~utils/array';
import { productsPropTypes } from '~propTypes/product';

import EmptyCart from './components/EmptyCart';

function ItemsCart({ items, productModalUrl }) {
  return arrayHasLength(items) ? (
    <div className="column">
      <OrderDetails isHome hasTitle={false} closeProductModalUrl={productModalUrl} />
    </div>
  ) : (
    <EmptyCart />
  );
}

ItemsCart.propTypes = {
  items: arrayOf(productsPropTypes).isRequired,
  productModalUrl: string.isRequired
};

export default ItemsCart;
